/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Goal_Running_DietInputs */

const en_portal_goal_running_diet = /** @type {(inputs: Portal_Goal_Running_DietInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carbs set for the long runs`)
};

const pl_portal_goal_running_diet = /** @type {(inputs: Portal_Goal_Running_DietInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Węglowodany ustawione pod długie biegi`)
};

/**
* | output |
* | --- |
* | "Carbs set for the long runs" |
*
* @param {Portal_Goal_Running_DietInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_goal_running_diet = /** @type {((inputs?: Portal_Goal_Running_DietInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Goal_Running_DietInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_goal_running_diet(inputs)
	return en_portal_goal_running_diet(inputs)
});